var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, Suspense, useCallback, useState } from "react";
import VTCanvas from "./VTCanvas";
import { useGLTF } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
function Model(_a) {
    var url = _a.url, cameraControls = _a.cameraControls, autoSpin = _a.autoSpin;
    var objectRef = useRef();
    var scene = useGLTF(url).scene;
    // const readyToSpinModelRef = useRef<boolean>(false);
    // const camera = useThree((state) => state.camera);
    // const renderer = useThree((state) => state.gl);
    // const orbitControlsRef = useRef<any>(null);
    useEffect(function () {
        if (cameraControls && objectRef && objectRef.current) {
            setTimeout(function () {
                cameraControls.fitToObject(objectRef.current, true);
                // window.setTimeout(() => {
                //     readyToSpinModelRef.current = true;
                //     // orbitControlsRef.current = new OrbitControls();
                //     // orbitControlsRef.current.update();
                // }, 1000);
            });
        }
    }, [cameraControls, objectRef.current]);
    useFrame(function () {
        // if (autoSpin && readyToSpinModelRef.current) {
        //     // @ts-ignore
        //     // camera.rotation.y += 0.1;
        //     // camera.rotation.x += 0.1;
        //     // camera.rotation.z += 0.1;
        //     // orbitControlsRef.current.update();
        //     console.log(camera);
        //     // objectRef.current!.rotation.y += 0.015;
        //     // @ts-ignore
        //     // objectRef.current.scale.set(0.3, 0.3, 0.3);
        // }
    });
    return (_jsx(Suspense, __assign({ fallback: null }, { children: _jsx("primitive", { ref: objectRef, object: scene, position: [0, 0, 5] }) })));
}
export default function VTCardModelPreview(_a) {
    var modelUrl = _a.modelUrl, autoSpin = _a.autoSpin;
    var _b = __read(useState(null), 2), cameraControls = _b[0], setCameraControls = _b[1];
    var camerasControlsRef = useCallback(function (val) {
        if (val && !cameraControls) {
            setCameraControls(val);
        }
    }, []);
    return (_jsxs(VTCanvas, __assign({ style: { objectFit: "cover", width: "100%", height: "100%" }, ref: camerasControlsRef }, { children: [_jsx("ambientLight", {}), _jsx("pointLight", { position: [1, 1, 1] }), modelUrl && _jsx(Model, { url: modelUrl, autoSpin: autoSpin, cameraControls: cameraControls })] })));
}
